export default "__VITE_ASSET__D4MQynzg__"